import { MDBDatatable } from "mdb-react-ui-kit";
import React from "react";

function SuccessValidationPage({
  createList,
  updateList,
  deleteList,
  skipUserList,
  totalSheetRecords,
  recordNoAction,
  recordsProcess,
  defaultCalleridFlag,
}) {
  // const totalRows = (createList?.length ?? 0) + (updateList?.length ?? 0) + (skipUserList?.length ?? 0) + (deleteList?.length ?? 0) ;
  let processRows1 = [];
  createList &&
    createList.map((info) => {
      processRows1.push({
        userInfo: info,
        firstName: info?.fname ?? "",
        lastName: info?.lname ?? "",
        email: info?.emailid ?? "",
        extension: info?.extension ?? "",
        servicePlan: info?.serviceplan ?? "",
        classtype: info?.classtype ? "Yes" : "No",
        callerId: info?.caller_id ?? "",
        did: info?.added_dids ?? "",
        location: info?.location ?? "",
        recordallcalls: info?.recordallcalls ?? "",
        billinggroup: info?.billinggroup ?? "",
        ip1macaddress: info?.ip1macaddress ?? "",
        ip2macaddress: info?.ip2macaddress ?? "",
        ip1nineolocation: info?.ip1nineolocation ?? "",
        ip2nineolocation: info?.ip2nineolocation ?? "",
        ip1model: info?.ip1model ?? "",
        ip2model: info?.ip2model ?? "",
        ip1no_mla: info?.ip1no_mla ?? "",
        ip2no_mla: info?.ip2no_mla ?? "",
        ip1mla: info?.ip1mla ?? "",
        ip2mla: info?.ip2mla ?? "",
        // ip1lable : info?.ip1lable ?? "",
        // ip2lable : info?.ip2lable ?? ""
      });
    });

  const actionData3 = {
    columns: [
      { label: "First Name", field: "firstName", sort: false },
      { label: "Last Name", field: "lastName", sort: false },
      { label: "Email Address", field: "email", sort: false },
      // { label: 'User ID', field: 'userId', sort: false },
      { label: "Extension", field: "extension", sort: false },
      { label: "Service Plan", field: "servicePlan", sort: false },
      {
        label: "International Calling Enabled",
        field: "classtype",
        sort: false,
      },
      // { label: 'Contract Term', field: 'contractTerm', sort: false },
      // { label: 'Intl. Calling Enabled?', field: 'intlCalling', sort: false },
      // { label: 'MLA', field: 'mla', sort: false },
      // { label: 'No. of MLA Lines', field: 'mlaLines', sort: false },
      { label: "Caller ID", field: "callerId", sort: false },
      { label: "DID", field: "did", sort: false },
      // { label: 'Phone Password', field: 'phonePassword', sort: false },
      // { label: 'Voicemail PIN', field: 'voicemailPin', sort: false },
      // { label: 'IP1 Mac ID', field: 'ip1MacId', sort: false },
      // { label: '911 Location', field: 'location', sort: false },
      { label: "Location", field: "location", sort: false },
      { label: "Record All Calls", field: "recordallcalls", sort: false },
      { label: "Billing Group", field: "billinggroup", sort: false },

      { label: "IP1 Macaddress", field: "ip1macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip1nineolocation", sort: false },
      { label: "IP1 Phone Make", field: "ip1model", sort: false },
      { label: "IP1 MLA", field: "ip1mla", sort: false },
      { label: "IP1 No. of MLA Lines", field: "ip1no_mla", sort: false },
      // { label: "IP1 Phone Label", field: "ip1lable", sort: false },
      { label: "IP2 Macaddress", field: "ip2macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip2nineolocation", sort: false },
      { label: "IP2 Phone Make", field: "ip2model", sort: false },
      { label: "IP2 MLA", field: "ip2mla", sort: false },
      { label: "IP2 No. of MLA Lines", field: "ip2no_mla", sort: false },
      // { label: "IP2 Phone Label", field: "ip2lable", sort: false }
    ],
    rows: processRows1,
  };

  let processRows2 = [];
  updateList &&
    updateList.map((info) => {
      processRows2.push({
        userInfo: info,
        firstName: info?.fname ?? "",
        lastName: info?.lname ?? "",
        email: info?.emailid ?? "",
        extension: info?.extension ?? "",
        servicePlan: info?.serviceplan ?? "",
        classtype: info?.classtype ? "Yes" : "No",
        callerId: info?.caller_id ?? "",
        did: info?.added_dids ?? "",
        location: info?.location ?? "",
        recordallcalls: info?.recordallcalls ?? "",
        billinggroup: info?.billinggroup ?? "",
        ip1macaddress: info?.ip1macaddress ?? "",
        ip2macaddress: info?.ip2macaddress ?? "",
        ip1nineolocation: info?.ip1nineolocation ?? "",
        ip2nineolocation: info?.ip2nineolocation ?? "",
        ip1model: info?.ip1model ?? "",
        ip2model: info?.ip2model ?? "",
        ip1no_mla: info?.ip1no_mla ?? "",
        ip2no_mla: info?.ip2no_mla ?? "",
        ip1mla: info?.ip1mla ?? "",
        ip2mla: info?.ip2mla ?? "",
        // ip1lable : info?.ip1lable ?? "",
        // ip2lable : info?.ip2lable ?? ""
      });
    });

  const actionData6 = {
    columns: [
      { label: "First Name", field: "firstName", sort: false },
      { label: "Last Name", field: "lastName", sort: false },
      { label: "Email Address", field: "email", sort: false },
      // { label: 'User ID', field: 'userId', sort: false },
      { label: "Extension", field: "extension", sort: false },
      { label: "Service Plan", field: "servicePlan", sort: false },
      {
        label: "International Calling Enabled",
        field: "classtype",
        sort: false,
      },
      // { label: 'Contract Term', field: 'contractTerm', sort: false },
      // { label: 'Intl. Calling Enabled?', field: 'intlCalling', sort: false },
      // { label: 'MLA', field: 'mla', sort: false },
      // { label: 'No. of MLA Lines', field: 'mlaLines', sort: false },
      { label: "Caller ID", field: "callerId", sort: false },
      { label: "DID", field: "did", sort: false },
      // { label: 'Phone Password', field: 'phonePassword', sort: false },
      // { label: 'Voicemail PIN', field: 'voicemailPin', sort: false },
      // { label: 'IP1 Mac ID', field: 'ip1MacId', sort: false },
      // { label: '911 Location', field: 'location', sort: false },
      { label: "Location", field: "location", sort: false },
      { label: "Record All Calls", field: "recordallcalls", sort: false },
      { label: "Billing Group", field: "billinggroup", sort: false },
      { label: "IP1 Mac ID", field: "ip1macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip1nineolocation", sort: false },
      { label: "IP1 Phone Make", field: "ip1model", sort: false },
      { label: "IP1 MLA", field: "ip1mla", sort: false },
      { label: "IP1 No. of MLA Lines", field: "ip1no_mla", sort: false },
      // { label: "IP1 Phone Label", field: "ip1lable", sort: false },
      { label: "IP2 Mac ID", field: "ip2macaddress", sort: false },
      { label: "IP1 911 Location", field: "ip2nineolocation", sort: false },
      { label: "IP2 Phone Make", field: "ip2model", sort: false },
      { label: "IP2 MLA", field: "ip2mla", sort: false },
      { label: "IP2 No. of MLA Lines", field: "ip2no_mla", sort: false },
      // { label: "IP2 Phone Label", field: "ip2lable", sort: false }
    ],
    rows: processRows2,
  };

  let processRows3 = [];
  deleteList &&
    deleteList.map((info) => {
      processRows3.push({
        userInfo: info,
        rowId: info?.rowid ?? "",
        emailid: info?.emailid ?? "",
        warnings: info?.warnings ?? "",
      });
    });

  const actionData5 = {
    columns: [
      { label: "Row ID", field: "rowId", sort: true },
      { label: "User ID", field: "emailid", sort: true },
      { label: "Warnings", field: "warnings", sort: true },
    ],
    rows: processRows3,
  };

  let processRows4 = [];
  skipUserList &&
    skipUserList.map((info) => {
      processRows4.push({
        userInfo: info,
        rowId: info?.rowid ?? "",
        emailid: info?.emailid ?? "",
        reason: info?.reason ?? "",
      });
    });

  const actionData7 = {
    columns: [
      { label: "Row ID", field: "rowId", sort: true },
      { label: "User ID", field: "emailid", sort: true },
      { label: "Reason", field: "reason", sort: true },
    ],
    rows: processRows4,
  };

  return (
    <>
      <div className="py-3 text-center">
        <p>Total uploaded Rows:{totalSheetRecords}</p>
        <p>Total Rows on which No Action taken: {recordNoAction}</p>
        <p>Total Rows to Process:{recordsProcess}</p>
      </div>
      {defaultCalleridFlag === 1 && (
        <p className="text-danger text-center">
          If caller ID field is EMPTY, then Account Default Caller ID will be
          assigned as users caller ID by default.
        </p>
      )}
      {createList && createList?.length > 0 && (
        <>
          <div
            className="my-2 text-left fs-6 p-3 bg-success bg-opacity-10 border-success border border-3"
            light
          >
            <strong>
              CREATE USERS(s): The following valid data has been found in the
              Spread Sheet to Create Users - {createList?.length ?? 0} Record(s)
            </strong>
          </div>

          <div className="mt-3 importExportDatatable">
            <div className="actionbar"></div>

            <MDBDatatable
              search
              hover
              className="actioncolumnbig"
              pagination={true}
              fixedHeader
              entries={50}
              data={actionData3}
              sortField="Name"
            />
          </div>

          <p className="text-center py-4 fw-bold">
            Note: The Voicemail PIN and Extension will be Auto generated if the
            respective fields are empty. Voicemail PIN is not applicable for
            Common Extension user(s).
          </p>
        </>
      )}
      {updateList && updateList?.length > 0 && (
        <>
          <div
            className="my-2 text-left fs-6 p-3 bg-success bg-opacity-10 border-success border border-3"
            light
          >
            <strong>
              EDIT USERS(s): The following valid data has been found in the
              Spread Sheet to Existing Users - {updateList?.length ?? 0}{" "}
              Record(s)
            </strong>
          </div>
          <div className="mt-3 importExportDatatable">
            <div className="actionbar"></div>

            <MDBDatatable
              search
              hover
              className="actioncolumnbig"
              pagination={true}
              fixedHeader
              entries={50}
              data={actionData6}
              sortField="Name"
            />
          </div>

          <p className="text-center py-4 fw-bold">
            {/* Note: If you are changing your Extension, you will be logged out
            from ACD Live Monitor. Voicemail Pin is not applicable for Common
            Extension User(s).{" "} */}
             Note: Voicemail Pin is not applicable for Common
            Extension User(s).{" "}
          </p>
        </>
      )}
      {deleteList && deleteList?.length > 0 && (
        <>
          <div
            className="my-2 text-left fs-6 p-3 bg-success bg-opacity-10 border-success border border-3"
            light
          >
            <strong>
              DELETE USER(S): The following data has been found in the Spread
              Sheet to Delete Users - {deleteList?.length ?? 0} Record(s)
            </strong>
          </div>

          <div className="pb-3 mt-3 importExportDatatable">
            <div className="actionbar"></div>

            <MDBDatatable
              search
              hover
              className=""
              pagination={true}
              data={actionData5}
              fixedHeader
              entries={50}
              sortField="Name"
            />
          </div>
        </>
      )}
      {skipUserList && skipUserList?.length > 0 && (
        <>
          <div
            className="my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3"
            light
          >
            <strong>
              <>
                {recordsProcess !== 0 ? (
                  <>
                    The following invalid data has been found in the Spread
                    Sheet which cannot be used to create/edit/delete the user(s)
                    - {skipUserList?.length ?? 0} Record(s)
                  </>
                ) : (
                  <>
                    No valid data was detected in the uploaded spreadsheet.
                    Please ensure the spreadsheet is fully filled out with valid
                    data and try uploading again
                  </>
                )}
              </>
            </strong>
          </div>
          {recordsProcess !== 0 && (
            <div className="importExportDatatable">
              <div className="actionbar"></div>
              <MDBDatatable
                search
                hover
                className=""
                pagination={false}
                data={actionData7}
                sortField="Name"
                entries={50}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default SuccessValidationPage;
